export default "__VITE_ASSET__Do$MN5PX__"